import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, IconButton, Skeleton, Stack, Typography, Button } from '@mui/material';
import parse, { DOMNode } from 'html-react-parser';
import { Download, Description } from '@mui/icons-material';
import { warning } from '_lex/_foundations/phxColors';
import PolicyContentHelper from 'views/App/Portal/Policy/_helpers/policyContentHelper';
import EditorSheet from '_lex/_atoms/EditorSheet';
import { Manual } from 'views/App/Portal/Policy/_types/manuals/draft';

function WrittenDirectivePreface({
  manualId,
  manual,
  preface,
  scrollId,
}: {
  manualId: string;
  manual?: Manual;
  preface?: any;
  scrollId?: string;
}) {
  const [params] = useSearchParams();
  const [showFullPreface, setShowFullPreface] = useState(true);

  useEffect(() => {
    if (scrollId) {
      const element = document.getElementById(`preface_${scrollId}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [scrollId]);

  return (
    <Stack>
      <EditorSheet>
        <Stack spacing={10}>
          {!preface ? (
            <Stack spacing={2}>
              <Skeleton
                variant='rectangular'
                height={28}
                width='50%'
              />
              <Stack>
                <Skeleton variant='text' />
                <Skeleton variant='text' />
                <Skeleton variant='text' />
              </Stack>
            </Stack>
          ) : (
            <>
              <Stack spacing={3}>
                <Typography variant='subtitleMd'>{manual?.name || ''}</Typography>
                <Typography variant='subtitleMd'>Preface</Typography>
                <Typography variant='displaySm'>{preface?.title || ''}</Typography>
              </Stack>

              <Stack
                id={`preface_${preface?.id}`}
                sx={{
                  backgroundColor: preface?.id.toString() === params.get('s') ? warning[50] : 'transparent',
                }}
              >
                {parse(preface?.content || '', {
                  replace(node: DOMNode, ind: number) {
                    return PolicyContentHelper.handleContent(node, ind);
                  },
                })}
              </Stack>
            </>
          )}
        </Stack>
      </EditorSheet>
    </Stack>
  );
}

export default WrittenDirectivePreface;
